/* Dogs Supreme – PDP Variant-Image Auto-Scroll v4 (2026-09-05)
 *
 * Verhalten:
 * - Auf Mobile/Tablet (<1024px) scrollt die Seite beim Variantenwechsel smooth zum Hauptbild,
 *   sodass das Bild im oberen Viertel des Viewports landet. NUR wenn das Variantenbild wirklich
 *   wechselt (Farbe). Ein Groessenwechsel teilt das Bild seiner Farbe und bewegt die Seite nicht.
 * - Auf Desktop: keine Aktion (Bild ist links statisch sichtbar).
 *
 * v3 (2026-05-11) scrollte bei JEDEM variant:change, zusaetzlich bei jedem Swatch-Klick und beim
 * Fallback ds:variantImageChanged, also bis zu dreimal fuer denselben Wechsel. Dazu lief in
 * ds-cart-bar.js (v23) dieselbe Logik ein zweites Mal, 720 ms versetzt. GF 05.09.2026 am Pilot
 * Air Mesh Pro: "klicke ich auf die Groesse, scrollt es hoch und ich sehe die Groesse nicht mehr."
 *
 * v4: ein Ausloeser (variant:change aus theme.js, synchron), ein Gate (Bildwechsel), ein Besitzer
 * (window.__dsVariantScrollOwner, die Kopie in ds-cart-bar.js tritt zurueck). Der Bild-Flash
 * (.ds-variant-flash, CSS in ds-cart-bar.css) wandert mit hierher.
 *
 * Gate: theme.js sendet variant:change (Zeile ~845) VOR _updateImages, die gewaehlte Slide traegt
 * also noch das alte Bild. Stimmt ihre data-id mit variant.featured_media.id ueberein, wechselt
 * das Bild nicht.
 *
 * Tracking: dataLayer.push `ds_variant_image_revealed` (GTM-Trigger noetig).
 */

(function() {
  'use strict';

  // Desktop ueberspringen
  if (window.matchMedia && window.matchMedia('(min-width: 1024px)').matches) return;

  window.__dsVariantScrollOwner = 'ds-pdp-variant-sticky';

  var DEBUG = /[?&]ds_debug=1/.test(location.search);
  function log() {
    if (!DEBUG) return;
    console.log.apply(console, ['[DS-VariantScroll]'].concat(Array.prototype.slice.call(arguments)));
  }

  // Image-Wrapper finden: erst v23-Klasse, dann Theme-Fallback
  function findImageWrap() {
    return document.querySelector('.js-pdp-sticky-mobile[data-variant-image-sync]') ||
           document.querySelector('.product__main-photos') ||
           document.querySelector('[data-product-single-media-group]') ||
           document.querySelector('[data-product-photos]');
  }

  function getHeaderHeight() {
    var hdr = document.querySelector('.site-header') ||
              document.querySelector('header') ||
              document.querySelector('.sn-header');
    return (hdr && hdr.offsetHeight) || 56;
  }

  function imageChanges(variant) {
    var media = variant && variant.featured_media;
    if (!media || media.id == null) return false;
    var selected = document.querySelector('.product-main-slide.is-selected[data-id]');
    if (!selected) return true; // Slide-Zustand unbekannt: wie bisher scrollen
    return String(selected.getAttribute('data-id')) !== String(media.id);
  }

  function flashImage(imgWrap) {
    var photos = imgWrap.classList.contains('product__main-photos') ? imgWrap : document.querySelector('.product__main-photos');
    if (!photos) return;
    photos.classList.remove('ds-variant-flash');
    window.requestAnimationFrame(function() { photos.classList.add('ds-variant-flash'); });
    setTimeout(function() { photos.classList.remove('ds-variant-flash'); }, 700);
  }

  function scrollToImage(variant) {
    var imgWrap = findImageWrap();
    if (!imgWrap) {
      log('imageWrap not found');
      return;
    }

    var headerH = getHeaderHeight();
    var rect = imgWrap.getBoundingClientRect();
    var pageY = window.pageYOffset || document.documentElement.scrollTop || 0;
    var imgPageTop = rect.top + pageY;
    var imgHeight = imgWrap.offsetHeight || rect.height || 375;

    // Ziel: Bild im oberen 25% des Viewports (Apple-Style „prominent placement")
    // - Wenn Bild kleiner als Viewport: 25% vom Top als breathing-space, Bild dominant
    // - Wenn Bild groesser als Viewport: knapp unter Header
    var vh = window.innerHeight;
    var spaceAbove;
    if (imgHeight + headerH + 32 >= vh) {
      spaceAbove = headerH + 8;
    } else {
      spaceAbove = headerH + Math.max(8, (vh - headerH - imgHeight) * 0.25);
    }
    var targetY = Math.max(0, imgPageTop - spaceAbove);

    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    log('scrolling to', { targetY: targetY, imgPageTop: imgPageTop, spaceAbove: spaceAbove, vh: vh, imgH: imgHeight });

    if (!reducedMotion) flashImage(imgWrap);

    try {
      window.scrollTo({ top: targetY, behavior: reducedMotion ? 'instant' : 'smooth' });
    } catch (err) {
      window.scrollTo(0, targetY);
    }

    if (window.dataLayer) {
      window.dataLayer.push({
        event: 'ds_variant_image_revealed',
        variant_id: variant ? variant.id : null,
        method: 'auto_scroll'
      });
    }
  }

  // Einziger Ausloeser: variant:change aus theme.js, nur bei echtem Bildwechsel
  document.addEventListener('variant:change', function(e) {
    var variant = e.detail && e.detail.variant;
    if (!variant) return;
    if (!imageChanges(variant)) {
      log('same image, no scroll', variant.title);
      return;
    }
    scrollToImage(variant);
  });

  log('initialized v4, breakpoint mobile/tablet');
})();
